/** Status projetados das análises de mercados de clientes */
export interface ClienteAnaliseMercadoStatusProjetado {
    id: number;
    nome: string;
}

export const statusProjetadoNaoProjetado: ClienteAnaliseMercadoStatusProjetado = {
    id: 1,
    nome: 'Não Projetado'
};
export const statusProjetadoProjetado: ClienteAnaliseMercadoStatusProjetado = {
    id: 2,
    nome: 'Projetado'
};
export const statusProjetadoEmNegociacao: ClienteAnaliseMercadoStatusProjetado = {
    id: 3,
    nome: 'Em Negociação'
};

export const statusProjetadoGanho: ClienteAnaliseMercadoStatusProjetado = {
    id: 4,
    nome: 'Ganho'
};

export const statusProjetadoPerdido: ClienteAnaliseMercadoStatusProjetado = {
    id: 5,
    nome: 'Perdido'
};

export const statusProjetados: ClienteAnaliseMercadoStatusProjetado[] = [
    statusProjetadoNaoProjetado,
    statusProjetadoProjetado,
    statusProjetadoEmNegociacao,
    statusProjetadoGanho,
    statusProjetadoPerdido
];


/** Verifica se o status projetado é igual a Não Projetado */
export function isStatusProjetadoNaoProjetado(status: number): boolean {
    if (!status) {
        return false;
    }
    return status === statusProjetadoNaoProjetado.id;
}

/** Verifica se o status projetado é igual a Projetado */
export function isStatusProjetadoProjetado(status: number): boolean {
    if (!status) {
        return false;
    }
    return status === statusProjetadoProjetado.id;
}

/** Verifica se o status projetado é igual a Em Negociação */
export function isStatusProjetadoEmNegociacao(status: number): boolean {
    if (!status) {
        return false;
    }
    return status === statusProjetadoEmNegociacao.id;
}


/** Verifica se o status projetado é igual a Ganho */
export function isStatusProjetadoGanho(status: number): boolean {
    if (!status) {
        return false;
    }
    return status === statusProjetadoGanho.id;
}

/** Verifica se o status projetado é igual a Perdido */
export function isStatusProjetadoPerdido(status: number): boolean {
    if (!status) {
        return false;
    }
    return status === statusProjetadoPerdido.id;
}
